export const it = {
  statDpiDelivered: {
    name: "DPI consegnati a operatori",
    period: "Periodo",
  },
};
